/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {makeStyles} from '@material-ui/core/styles';
import {dlsColor} from '../../theme/theme';

/**
 * Provides the styles shared by the current theme's geofence cards (the
 * create geofence card and the vicinity search card): body, description,
 * field labels, search field and actions. The labels use 'Roboto', the
 * current theme's alias for its Archivo Narrow font files (see
 * public/themes/current/fonts.css).
 *
 * ```typescript
 *
 *   import {useGeofenceCardStyles} from
 *     '@ion/dls/src/maps/geofences/geofenceCardStyles';
 *   ...
 *
 *   const cardClasses = useGeofenceCardStyles();
 *
 * ```
 *
 * @returns The card class names.
 */
export const useGeofenceCardStyles = makeStyles(() => ({
  body : {
    display       : 'flex',
    flexDirection : 'column',
    gap           : 16,
    padding       : '0 16px'
  },
  description : {
    margin     : 0,
    padding    : '8px 0',
    fontFamily : 'Inter',
    fontWeight : 400,
    fontSize   : '16px',
    lineHeight : '22px',
    color      : dlsColor('lightTeal')
  },
  searchGroup : {
    display       : 'flex',
    flexDirection : 'column',
    gap           : 4
  },
  label : {
    fontFamily    : 'Roboto',
    fontWeight    : 700,
    fontSize      : '14px',
    lineHeight    : '16px',
    letterSpacing : '0.5px',
    color         : dlsColor('grey2')
  },
  // a plain block box for the address search - SearchAddress's own root
  // uses `display: inherit`, which would otherwise pick up the enclosing
  // flex layout and set its results beside the field instead of below ...
  searchField : {
    display : 'block',
    width   : '100%'
  },
  actions : {
    display        : 'flex',
    alignItems     : 'center',
    justifyContent : 'flex-end',
    gap            : 8,
    minHeight      : 56
  }
}));

export default useGeofenceCardStyles;
